module.exports = __webpack_public_path__ + "img/nfc-fail.08c0e266.svg";